// @flow
import { Info } from 'lucide-react';
import { Link, Text, Tooltip, View } from 'reshaped';

import { useTranslator } from '@gandi/translate';

export function ZipHelp(): React.MixedElement {
  const { __ } = useTranslator();
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span onMouseDown={e => e.stopPropagation()}>
      <Tooltip
        text={
          <View padding={1}>
            {/* $FlowFixMe[prop-missing] */}
            <Text
              attributes={{
                dangerouslySetInnerHTML: __(
                  'View ' +
                    // FIXME: This link is not focusable/clickable via keyboard navigation because of the Reshaped tooltip.
                    '<a href="https://en.wikipedia.org/wiki/List_of_postal_codes" target="_blank" ' +
                    'rel="noopener noreferrer" tabIndex="-1">List of Postal Codes</a> on Wikipedia.',
                  { withHTML: true },
                ),
              }}
            />
          </View>
        }
      >
        {attributes => (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            icon={Info}
            variant="plain"
            color="inherit"
            // $FlowFixMe[incompatible-type-arg]
            // $FlowFixMe[incompatible-type]
            // $FlowFixMe[prop-missing]
            attributes={attributes}
          >
            {__('Need help?')}
          </Link>
        )}
      </Tooltip>
    </span>
  );
}
